import { stringify } from 'qs';

const STRINGIFY_OPTIONS = {
  format: 'RFC1738',
  addQueryPrefix: true,
  sort: (a, b) => (a.localeCompare(b)),
};

// How many users the picker shows at once; typing narrows past this.
export const ASSIGNEE_PAGE_SIZE = 25;

// Searches the organization's assignable users, for the Assign, Bulk Assign and
// Reassign modals. /api/v1/department_users returns [email, name, id] rows --
// note the order -- so the option VALUE is the email the assign endpoints look
// up by. Users with no name are labelled by their email.
//
// Resolves `{ options, total }`; `total` is the server's count of every match,
// which can exceed the page shown. Rejects when the request fails, so the
// picker can say so rather than claim nobody matched.
//
// The options come off this response rather than out of redux. `searchAssignableUsers`
// deliberately stores nothing there, so the picker cannot overwrite the full staff
// list other screens read from userProfile.departmentUsers.
export const fetchAssigneeOptions = async ({ value, searchAssignableUsers }) => {
  const query = { contains: value || undefined, page: 1, page_size: ASSIGNEE_PAGE_SIZE };
  const response = await searchAssignableUsers(stringify(query, STRINGIFY_OPTIONS));
  if (response?.error) throw new Error('Could not load assignable users');

  const users = response?.data?.users || [];
  const options = users.map(([email, name]) => ({ value: email, label: name || email, email }));
  const total = Number(response?.data?.meta?.total_count) || options.length;

  return { options, total };
};

export default fetchAssigneeOptions;
